import { faWifi } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function updateCalibration() {
    return (
        <div data-cy="historic-icon-updateCalibration">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.updateCalibration" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faWifi} rotation={180} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
